import { render } from "./About.vue?vue&type=template&id=02a20861&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=02a20861&scoped=true&lang=css"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a20861"]])

export default __exports__